export enum ScheduleType {
  'None' = 0,
  'Regular' = 1,
  'Asap' = 2,
  'Out Of Schedule' = 3,
}
